@if (!embedded) {
  <app-navbar></app-navbar>
}
<div [class]="embedded ? '' : 'container-fluid mt-4'">
  @if (!embedded) {
    <a routerLink="/admin" class="back-link"><i class="bi bi-arrow-left"></i> Back to Admin</a>
    <h2 class="mb-4"><i class="bi bi-grid me-2"></i> Areas</h2>
  }
  <div class="card">
    <div class="card-body">
      <div class="d-flex flex-wrap align-items-center gap-3 mb-3">
        <label class="text-muted mb-0">Seed:</label>
        <select class="form-select" style="width: auto; min-width: 10rem; max-width: 18rem" [ngModel]="selectedSeedId" (ngModelChange)="selectedSeedId = $event; onSeedChange()">
          @for (s of seeds; track s.id) {
            <option [ngValue]="s.id">{{ s.name }}</option>
          }
        </select>
        <label class="text-muted mb-0">Subject:</label>
        <select class="form-select w-auto" [ngModel]="filterSubjectId" (ngModelChange)="onSubjectChange($event)">
          @for (s of subjects; track s.id) {
            <option [ngValue]="s.id">{{ s.name }}</option>
          }
        </select>
        <label class="text-muted mb-0">Topic:</label>
        <select class="form-select w-auto" [ngModel]="filterTopicId" (ngModelChange)="filterTopicId = $event; onFilterChange()">
          @for (t of topics; track t.id) {
            <option [ngValue]="t.id">{{ t.name }}</option>
          }
        </select>
        <button type="button" class="btn btn-primary ms-auto" (click)="openCreate()">Create Area</button>
      </div>
      @if (error) {
        <div class="alert alert-danger">{{ error }}</div>
      }
      @if (message) {
        <div class="alert alert-success">{{ message }}</div>
      }
      @if (loading) {
        <p class="text-muted">Loading…</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th (click)="setSort('topicId')" class="sortable"><span class="me-1">Topic</span><i [class]="'bi ' + sortIcon('topicId')"></i></th>
                <th (click)="setSort('name')" class="sortable"><span class="me-1">Name</span><i [class]="'bi ' + sortIcon('name')"></i></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (a of sortedContent; track a.id) {
                <tr class="clickable-row" (click)="openEdit(a)" role="button" tabindex="0">
                  <td>{{ topicName(a.topicId) }}</td>
                  <td>{{ a.name }}</td>
                  <td (click)="$event.stopPropagation()">
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="openDeleteConfirm(a)" >Delete</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (sortedContent.length === 0) {
          <p class="text-muted mb-0">No areas.</p>
        }
      }
    </div>
  </div>
</div>

@if (detailItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ detailItem.id == null ? 'Create area' : 'Edit area' }}</h5>
          <button type="button" class="btn-close" (click)="closeDetail()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-2">
            <label class="form-label">Topic <span class="text-danger">*</span></label>
            <select class="form-select" [(ngModel)]="detailForm.topicId">
              <option [ngValue]="null">—</option>
              @for (t of topics; track t.id) {
                <option [ngValue]="t.id">{{ t.name }}</option>
              }
            </select>
          </div>
          <div class="mb-2">
            <label class="form-label">Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="detailForm.name" placeholder="Area name">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDetail()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="detailSaving" (click)="save()">Save</button>
        </div>
      </div>
    </div>
  </div>
}

@if (deleteItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete area</h5>
          <button type="button" class="btn-close" (click)="closeDeleteConfirm()"></button>
        </div>
        <div class="modal-body">
          @if (deleteError) {
            <div class="alert alert-danger">{{ deleteError }}</div>
          }
          <p>Delete area <strong>{{ deleteItem.name }}</strong>? This cannot be undone.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDeleteConfirm()">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="confirmDelete()" >Delete</button>
        </div>
      </div>
    </div>
  </div>
}
